import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import CloseIcon from "@mui/icons-material/Close";
import Select from "react-select";

export default function Version() {
  

  const { showPage, setShowPage, accessObject } = useAppContext();
  const { socket } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [platformFilter, setPlatformFilter] = React.useState("all");
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderRadius: "10px",
      border: state.isFocused ? "1.5px solid #ffc107" : "1.5px solid #e2e8f0",
      boxShadow: state.isFocused ? "0 0 0 4px rgba(255, 193, 7, 0.15)" : "0 1px 2px rgba(0, 0, 0, 0.03)",
      padding: "2px 8px",
      fontSize: "0.95rem",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: state.isFocused ? "#ffc107" : "#cbd5e1",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#ffc107"
        : state.isFocused
          ? "rgba(255, 193, 7, 0.1)"
          : "#fff",
      color: state.isSelected ? "#000" : "#1e293b",
      padding: "10px 15px",
      cursor: "pointer",
      "&:active": {
        backgroundColor: "#ffc107",
      },
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "12px",
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
      overflow: "hidden",
      border: "1px solid #e2e8f0",
      zIndex: 9999,
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#1e293b",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#94a3b8",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: "#64748b",
      "&:hover": {
        color: "#1e293b",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  React.useEffect(() => {
    getBranch(platformFilter);
  }, [platformFilter]);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "—";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yy = String(d.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  };

  const LoginSchema = Yup.object().shape({
    version: Yup.string().required("Version is required"),
    code: Yup.number()
      .typeError("Code must be a number")
      .required("Version code is required"),
    platform: Yup.string().required("Platform is required"),
    status: Yup.string().required("Status is required"),
    version_url: Yup.string().required("Version URL is required"),
    description: Yup.string().required("Description is required"),
    date: Yup.string().required("Date is required"),
  });

  const getBranch = (platform) => {
    setLoader(true);
    const params = platform && platform !== "all" ? `?platform=${platform}` : "";
    axios(`${API_URL}/api/admin/version/get-version${params}`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);
        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
        setLoader(false);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const data = { ...value, id: rowValue._id };
    console.log("data::: ", data);

    axios
      .patch(
        `${API_URL}/api/admin/version/update-version-control/${rowValue._id}`,
        data
      )
      .then((res) => {
        console.log("update :::", res.data);
        if (res.data.status) {
          setButtonLoader(false);
          socket.emit("updateVersion");
          successEdit(res.data.message);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setButtonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/admin/version/add-version-control`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.status) {
          setButtonLoader(false);
          socket.emit("addVersion");
          successAdd(result.data.message);
        }
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
        setButtonLoader(false);
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this version record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = (msg) => {
    setAlert(
      <SweetAlert
        success
        title="Success"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">{msg || "The version record has been successfully removed."}</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    const data = { id: e._id };
    axios
      .delete(
        `${API_URL}/api/admin/version/delete-version-control/${e._id}`,
        data
      )
      .then((res) => {
        if (res.data.status) {
          socket.emit("deleteVersion");
          successDeleted(res.data.message);
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const successEdit = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3">
          <div className="card p-4">
            <h5 className="mb-4">
              <b>{openValue === 1 ? "Add Version" : "Edit Version"}</b>
            </h5>
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  version: rowValue ? rowValue?.version : "",
                  code: rowValue ? rowValue?.code : "",
                  platform: rowValue ? rowValue?.platform : "android",
                  is_force_update: rowValue ? rowValue?.is_force_update : false,
                  version_url: rowValue ? rowValue?.version_url : "",
                  description: rowValue ? rowValue?.description : "",
                  date: rowValue ? (rowValue?.date ? rowValue.date.split("T")[0] : "") : "",
                  status: rowValue ? rowValue?.status : "active",
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setButtonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  if (openValue === 1) addNewTournament(values);
                  if (openValue === 2) updateTournament(values);
                }}
              >
                {({ touched, errors }) => (
                  <Form>
                    {/* Row 1: Version + Version Code */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Version <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="version"
                            placeholder="e.g. 1.0.0"
                            className={`mt-1 form-control ${touched.version && errors.version ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="version" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Version Code <span className="text-danger">*</span></label>
                          <Field
                            type="number"
                            name="code"
                            placeholder="e.g. 1"
                            className={`mt-1 form-control ${touched.code && errors.code ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="code" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    {/* Row 2: Platform + Status */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Platform <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="platform"
                            className={`mt-1 form-control ${touched.platform && errors.platform ? "is-invalid" : ""}`}
                          >
                            <option value="android">Android</option>
                            <option value="ios">iOS</option>
                            <option value="admin">Admin</option>
                          </Field>
                          <ErrorMessage component="div" name="platform" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Status <span className="text-danger">*</span></label>
                          <Field
                            as="select"
                            name="status"
                            className={`mt-1 form-control ${touched.status && errors.status ? "is-invalid" : ""}`}
                          >
                            <option value="active">Active</option>
                            <option value="development">Development</option>
                            <option value="testing">Testing</option>
                          </Field>
                          <ErrorMessage component="div" name="status" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    {/* Row 3: Force Update + Date */}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Force Update</label>
                          <Field
                            as="select"
                            name="is_force_update"
                            className={`mt-1 form-control ${touched.is_force_update && errors.is_force_update ? "is-invalid" : ""}`}
                          >
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </Field>
                          <ErrorMessage component="div" name="is_force_update" className="invalid-feedback" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Date <span className="text-danger">*</span></label>
                          <Field
                            type="date"
                            name="date"
                            className="mt-1 form-control"
                          />
                          <ErrorMessage component="div" name="date" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    {/* Row 4: Version URL (full width) */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Version URL <span className="text-danger">*</span></label>
                          <Field
                            type="text"
                            name="version_url"
                            placeholder="https://play.google.com/store/apps/..."
                            className={`mt-1 form-control ${touched.version_url && errors.version_url ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="version_url" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    {/* Row 5: Description (full width) */}
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>Description <span className="text-danger">*</span></label>
                          <Field
                            as="textarea"
                            rows={3}
                            name="description"
                            placeholder="Change log or description..."
                            className={`mt-1 form-control ${touched.description && errors.description ? "is-invalid" : ""}`}
                          />
                          <ErrorMessage component="div" name="description" className="invalid-feedback" />
                        </div>
                      </div>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex mt-3">
                      <button
                        style={{ width: "110px", height: "38px" }}
                        type="submit"
                        className="btn btn-primary mr-2"
                        disabled={buttonLoader}
                      >
                        <div className="d-flex align-items-center justify-content-center">
                          <b>Submit</b>
                          {buttonLoader && (
                            <div
                              className="spinner-border ml-2"
                              role="status"
                              style={{ height: "16px", width: "16px" }}
                            />
                          )}
                        </div>
                      </button>
                      <button
                        style={{ width: "110px", height: "38px" }}
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn btn-secondary ms-2"
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card " style={{ overflow: "scroll" }}>
            <div className="card-header bg-white border-bottom-0 pb-0 pt-4 px-4">
              <div className="row align-items-end">
                <div className="col-md-4 mb-3 mb-md-0">
                  <label className="small text-muted font-weight-bold mb-1">Filter by Platform</label>
                  <div className="position-relative" style={{ minWidth: "200px", maxWidth: "250px" }}>
                    <Select
                      options={[
                        { value: "all", label: "All Platforms" },
                        { value: "android", label: "Android" },
                        { value: "ios", label: "iOS" },
                      ]}
                      value={{
                        value: platformFilter,
                        label: platformFilter === "all" ? "All Platforms" : platformFilter === "android" ? "Android" : "iOS"
                      }}
                      onChange={(option) => {
                        setPlatformFilter(option.value);
                        setPagination({ start: 0, end: showPrePage });
                      }}
                      styles={customStyles}
                      isSearchable={false}
                    />
                  </div>
                </div>
                <div className="col-md-8 text-right">
                  {accessObject?.addRoomTier === true && (
                    <button
                      onClick={() => {
                        openAddTournament(1);
                      }}
                      type="button"
                      className="btn btn-primary"
                    >
                      <AddIcon /> Add New
                    </button>
                  )}
                </div>
              </div>
            </div>

            <div class="card-body">
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th style={{ width: "60px" }}>Sr No</th>
                    <th style={{ width: "100px" }}>Platform</th>
                    <th style={{ width: "120px" }}>Version</th>
                    <th style={{ width: "100px" }}>Date</th>
                    <th style={{ width: "100px" }}>Status</th>
                    <th style={{ width: "110px" }}>Force Update</th>
                    {(accessObject?.editRoomTier === true ||
                      accessObject?.deleteRoomTier === true) && (
                        <th style={{ textAlign: "center", width: "100px" }}>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getRoomTier === true ? (
                    <>
                      {!loader ? (
                        <>
                          {tableData.length > 0 ? (
                            <>
                              {tableData
                                .reverse()
                                ?.slice(pagination.start, pagination.end)
                                .map((item, index) => (
                                  <>
                                    <tr key={index}>
                                      <td>{index + 1 + pagination.start}</td>
                                      <td style={{ textTransform: "capitalize" }}>
                                        {item.platform}
                                      </td>
                                      <td>{item.version} ({item.code})</td>
                                      <td>{formatDate(item.date)}</td>
                                      <td>
                                        <span
                                          className={`badge ${item.status === "active"
                                            ? "badge-success"
                                            : item.status === "testing"
                                              ? "badge-warning"
                                              : "badge-info"
                                            }`}
                                          style={{ textTransform: "capitalize" }}
                                        >
                                          {item.status}
                                        </span>
                                      </td>
                                      <td>
                                        {item.is_force_update ? (
                                          <span className="badge badge-danger">
                                            Yes
                                          </span>
                                        ) : (
                                          <span className="badge badge-secondary">
                                            No
                                          </span>
                                        )}
                                      </td>
                                      <td className="justify-content-evenly ">
                                        <div className="d-flex">
                                          {accessObject?.editRoomTier === true && (
                                            <EditIcon
                                              className="mr-3 courser"
                                              onClick={() => clickEditButton(item)}
                                            />
                                          )}
                                          {accessObject?.deleteRoomTier === true && (
                                            <ClearIcon
                                              className="courser text-danger"
                                              onClick={() => warningWithConfirmMessage(item)}
                                            />
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                ))}
                            </>
                          ) : (
                            <>
                              <EmptyState colSpan={9} />
                            </>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={9} className="p-3">
                        <h5 className="text-center mb-0">Access Denied</h5>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {accessObject?.getRoomTier === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
